import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.js';

var voidElements={"area":true,"base":true,"br":true,"col":true,"embed":true,"hr":true,"img":true,"input":true,"link":true,"meta":true,"param":true,"source":true,"track":true,"wbr":true};var e = getDefaultExportFromCjs(voidElements);

export { e as default };
//# sourceMappingURL=index.js.map
